// removed by extract-text-webpack-plugin
module.exports = {"EditCreatePerson":"EditCreatePerson--2VYfC"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Pages/Person/EditCreatePerson.scss
// module id = 948
// module chunks = 1